module.exports = __webpack_public_path__ + "static/jigyo2-ef56ee751b129dbdba683731019e6431.jpg";